export default `<!-- If your WordPress theme outputs the wp_head() function then, when enabled, the SparkLayer plugin will automatically register SparkLayer scripts -->
<!-- Script options can be modified in your WordPress Admin under the "SparkLayer B2B" plugin settings -->
<head>
	<?php wp_head(); ?>
</head>

<!-- If for any reason your theme does not output wp_head(); then you may optionally include the scripts manually -->

<script async src="#SPARKJS_URL#"></script>
<script>
window.sparkOptions = {
  siteId: "#SITE_ID#",#DOMAIN#
  platform: "woocommerce"
};
</script>
<!-- required for linking to order or quotes: https://docs.sparklayer.io/my-account-interface#yT5mS -->
<script async src="https://cdn.sparklayer.io/spark-redirect.js"></script>
`;
